import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  defaultLandscape: false,
  landscapeTitle: null,
  defaultVertical: false,
  verticalTitle: null,
};

export const axisTitleSlice = createSlice({
  name: "axisTitle",
  initialState,
  reducers: {
    updateDefaultLandscape: (state, action) => {
      return {
        ...state,
        defaultLandscape: !state.defaultLandscape,
      };
    },
    updateDefaultVertical: (state, action) => {
      return {
        ...state,
        defaultVertical: !state.defaultVertical,
      };
    },
    updateLandscapeTitle: (state, action) => {
      return {
        ...state,
        landscapeTitle: action.payload,
      };
    },
    updateVerticalTitle: (state, action) => {
      return {
        ...state,
        verticalTitle: action.payload,
      };
    },
  },
});

export const {
  updateDefaultLandscape,
  updateDefaultVertical,
  updateLandscapeTitle,
  updateVerticalTitle,
} = axisTitleSlice.actions;

export default axisTitleSlice.reducer;
